//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { update, fetch } from '@/apis/receipt'




export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            barCode: [{ required: true, message: '[barCode] Required!' }],
            itemCode: [{ required: true, message: '[商品貨號] Required!' }],
            itemName: [{ required: true, message: '[品名] Required!' }],
            unitBox: [{ required: true, message: '[每箱包裝數] Required!' }],
            cardNumber: [{ required: true, message: '[對應制卡編號] Required!' }],
        };
        const formData = {
            serial_no: "",
            barcode: "",
            item_code: "",
            item_name: "",
            work_order_no: "",
            no_package_first_num: 0,
            no_package_remain_num: 0,
            package_first_num: 0,
            package_remain_num: 0,
            label_first_num: 0,
            label_remain_num: 0,
            label_consume_num: 0,
        };
        return {
            id: 0,
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await fetch({ id: this.id });
                if (res.code == 200) {
                    this.formData = res.data;
                    console.log(`output->this.formData`, this.formData)
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },

        onFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            const form = { ...this.formData };

            try {
                this.spinning = true;
                const res = await update(form);
                if (res.code == 200) {
                    this.$message.success('Succed');
                    this.$router.push('/receipt');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
